<section class="card">
  <div class="widget-container" [ngClass]="extraClass">
    <h3>{{ title }}</h3>

    @if (loading) {
      <div class="loading-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    } @else if (list.length === 0) {
      <span class="empty-msg">
        {{ emptyMessage }}
      </span>
    } @else {
      <ul class="list-container">
        @for (item of list; track item.title) {
          <li (click)="goLink(item.link)" [ngClass]="{ 'link': item.link != null }">
            @if (item.icon != null) {
              <div class="service-icon">
                <mat-icon [inline]="true">{{ item.icon }}</mat-icon>
              </div>
            }
            <div class="info">
              <span class="val">{{ item.value }}</span>
              <span class="label">{{ item.title }}</span>
            </div>
            @if (showLinks) {
              <div class="arrow">
                <mat-icon [inline]="true">chevron_right</mat-icon>
              </div>
            }
          </li>
        }
      </ul>
    }
  </div>
</section>
